<ling-input-base
  [label]="label + ' (' + acceptListExtensionsString + ')'"
  [info]="info"
  [isRequired]="isRequired"
  [error]="error"
  [removeButton]="removeButton"
  (removeButtonPress)="onRemoveButtonPressed()"
  [isEditButton]="isEditButton"
  [editButtonInfo]="editButtonInfo"
  (editButtonPress)="editButtonPress.emit()"
  [disabledInput]="disabledInput"
>
  <input
    type="file"
    (change)="onFileInputChange($event)"
    hidden
    #fileInput
    [multiple]="type !== 'avatar'"
    [accept]="acceptListString"
  />
  <div
    *ngIf="type === 'certificate'"
    class="ling-file-input"
    [class.error-input]="error"
    [class.in-focus]="isFocused"
  >
    <div
      class="drop-overlay"
      [class.drop-overlay-active]="!disabledInput && (pipedIsDragging$ | async)"
    >
      <mat-icon fontIcon="upload"></mat-icon>
      <span>{{ "fileInputDropFilesHere" | translate }}</span>
    </div>
    <button
      class="add-file-button file-item"
      [class.disabled]="disabledInput"
      type="button"
      [disabled]="disabledInput"
      *ngIf="!disabledInput && !(control.value?.length >= maxFiles)"
      (click)="openAddFileDialog()"
    >
      <div class="add-file-icon"></div>
    </button>
    <ng-container *ngFor="let file of control.value; let i = index">
    <div
      *ngIf="file"
      class="file-item"
      #fileItem
      [matTooltip]="isVanillaFile(file) ? file.name : file.file?.originalname"
      [matTooltipPosition]="'above'"
    >
      <ng-container *ngIf="isFileCanBeShown(file)">
        <img
          *ngIf="isAppropriateBaseMimeType('image', file)"
          [src]="localLinksMap[i]"
          (error)="image.src = 'assets/img/error.svg'"
          #image
          class="file-preview"
          [alt]="'Uploaded image'"
        />
        <video
          *ngIf="isAppropriateBaseMimeType('video', file)"
          [src]="localLinksMap[i]"
          class="file-preview"
        ></video>
      </ng-container>
      <div
        *ngIf="
          !isFileCanBeShown(file) ||
          isAppropriateBaseMimeType('application/pdf', file)
        "
        class="file-preview file-preview_generic"
      >
        <mat-icon
          class="material-symbols-outlined"
          *ngIf="isAppropriateBaseMimeType('application/pdf', file)"
          >description</mat-icon
        >
        <mat-icon
          class="material-symbols-outlined"
          *ngIf="isAppropriateBaseMimeType('image', file)"
          >image</mat-icon
        >
        <mat-icon
          class="material-symbols-outlined"
          *ngIf="isAppropriateBaseMimeType('audio', file)"
          >audio_file</mat-icon
        >
        <mat-icon
          class="material-symbols-outlined"
          *ngIf="isAppropriateBaseMimeType('video', file)"
          >video_file</mat-icon
        >
        <mat-icon
          class="material-symbols-outlined"
          *ngIf="isAppropriateBaseMimeType(documentMimeType.XLSX, file) || isAppropriateBaseMimeType(documentMimeType.CSV, file)"
        >list_alt</mat-icon
        >
      </div>
      <div
        *ngIf="!disabledInput"
        #deleteOverlay
        class="file-item-overlay"
        [class.file-item-overlay-disabled]="isVanillaFile(file) && filesLoading"
        (click)="onRemoveFile(i)"
      >
        <mat-icon fontIcon="delete"></mat-icon>
      </div>
      <div class="loading-overlay" *ngIf="isVanillaFile(file) && filesLoading">
        <mat-progress-spinner
          mode="indeterminate"
          [diameter]="50"
        ></mat-progress-spinner>
      </div>
    </div>
    </ng-container>
  </div>
  <div *ngIf="type === 'avatar'" class="ling-profile-picture-input">
    <div
      class="profile-picture-content"
      [class.error-input]="error"
      [class.in-focus]="isFocused"
    >
      <div
        class="drop-overlay"
        [class.drop-overlay-active]="pipedIsDragging$ | async"
      >
        <mat-icon fontIcon="upload"></mat-icon>
      </div>
      <div
        class="upload-click-overlay"
        (click)="!disabledInput && fileInput.click()"
        *ngIf="!control.value?.[0]"
      ></div>
      <div class="loading-overlay" *ngIf="filesLoading">
        <mat-progress-spinner
          mode="indeterminate"
          [diameter]="50"
        ></mat-progress-spinner>
      </div>
      <div
        *ngIf="control.value?.[0]"
        class="file-item"
        #fileItem
        [matTooltip]="
          isVanillaFile(control.value?.[0])
            ? control.value?.[0].name
            : control.value?.[0].file?.originalname
        "
        [matTooltipPosition]="'above'"
      >
        <img
          *ngIf="isAppropriateBaseMimeType('image', control.value[0])"
          [src]="localLinksMap[0]"
          (error)="image.src = 'assets/img/no-avatar.svg'"
          #image
          class="file-preview"
          [alt]="'Uploaded image'"
        />
        <div
          *ngIf="!disabledInput"
          #deleteOverlay
          class="file-item-overlay"
          [class.file-item-overlay-disabled]="
            isVanillaFile(control.value[0]) && filesLoading
          "
          (click)="onRemoveFile(0)"
        >
          <mat-icon fontIcon="delete"></mat-icon>
        </div>
      </div>
    </div>
    <button
      class="profile-picture-action-button"
      type="button"
      *ngIf="!disabledInput && (pipedIsDragging$ | async) === false && !filesLoading"
      [disabled]="disabledInput"
      (click)="!disabledInput && fileInput.click()"
    >
      <mat-icon fontIcon="add"></mat-icon>
    </button>
  </div>
</ling-input-base>
